<template style="overflow: hidden;">
    <v-img
      src="https://elasticbeanstalk-us-west-2-476610144907.s3-us-west-2.amazonaws.com/sean-pollock-PhYq704ffdA-unsplash.jpg"
      style="overflow-y:hidden; height:auto;"
    >
      <v-container class="login_wrapper" grid-list-md text-xs-center>
        <v-layout class="animate form login_form text-center">
          <v-flex xl3 lg4 offset-lg4 md5 offset-md4 sm6 xs12 class="login_content mx-auto px-auto">
            <v-card class="elevation-24" style="opacity:0.95;border-radius:10px;">
              <v-form
                ref="resetForm"
                lazy-validation
                class="form-horizontal py-2 px-5"
                @submit.prevent="submit"
                style="background: #FFF; margin-top: 150px;"
              >
                <h4>Password Reset</h4>

                <template
                  v-if="!isExpired"
                >

                  <v-progress-linear
                  :indeterminate="processBar"
                  class="my-0"
                  :height="height"
                  :background-opacity="opacity"
                  ></v-progress-linear>
                  
                  <v-flex></v-flex>
                  <v-flex>
                    <v-text-field
                    :error-messages="errors"
                    id="password"
                    :rules="[v => !!v || 'password is required']"
                    type="password"
                    v-model="password"
                    label="Password"
                    placeholder="************"
                    required
                    prepend-inner-icon="lock"
                    ></v-text-field>
                  </v-flex>
                  
                  <v-flex>
                    <v-text-field
                    id="retype_password"
                    :rules="[v => !!v || 'Retype password is required']"
                    type="password"
                    v-model="retype_password"
                    label="Retype Password"
                    v-on:keyup.enter="submit"
                    placeholder="************"
                    required
                    prepend-inner-icon="lock"
                    ></v-text-field>
                  </v-flex>
                  
                  <div>
                    <v-btn
                    block
                    color="success"
                    @click="submit"
                    class="btn btn-default"
                    id="submit_btn"
                    primary
                    ref="loginButton"
                    >Reset</v-btn>
                  </div>
                  <br />
                  <div class="clearfix"></div>
                  <v-divider></v-divider>
                  <div align-self-center>
                    <img
                    src="https://mcawizardfiles.s3.us-west-2.amazonaws.com/5a7b498faf1dc.Alex.LOGO%20MCA.png"
                    style="height:25px; width:135px;"
                    />
                    <div class="caption grey--text">©2018 All Rights Reserved.</div>
                    <!--<div class="caption grey--text" id="demo"></div>-->
                  </div>
                </template>
                <template v-else>
                  <div>
                    <h4>Link Expired</h4>
                    <p>
                      The link you are trying to access is expired. Please request a new link.
                    </p>
                  </div>
                </template>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
  </template>
  <script>
  import axios from "axios";
  import { URL } from '../../../env'
  export default {
    data() {
      return {
        errors: null,
        password: "",
        email: "",
        user_id: null,
        retype_password: "",
        opacity: 0,
        height: 4,
        processBar: false,
        image:
          "https://mcawizardfiles.s3.us-west-2.amazonaws.com/5d5eeddf21b2clogin-screen.png"
      };
    },
    mounted() {
      let id = this.$route.query.id;
      this.user_id = id;
    },
    computed: {
      isExpired() {
        let expires = this.$route.query.expires;
        let date = new Date();
        let timeInMillisecond = date.getTime();
        let unixTimestamp = Math.floor(date.getTime() / 1000);
        if (parseInt(expires) < unixTimestamp) {
          return true;
        } else {
          return false;
        }
      }
    },
    methods: {
      submit() {
        if (this.$refs.resetForm.validate()) {
          if (this.password === this.retype_password) {
            this.processBar = true;
            this.errors = [];
            this.$refs.loginButton.disabled = true;
            axios.post(`${URL}/user/reset_password`, {
                id: atob(this.user_id),
                password: btoa(this.password)
            })
              .catch(err => {
                this.errors.push(err);
                this.processBar = false;
              })
              .then(response => {
                alert(response.data.message);
          
                this.processBar = false;
                this.$router.push("/login");
                window.close();
              });
          } else {
            alert("Password doesn't match");
          }
        }
      }
    }
  };
  </script>
  <style>
  /* ADDS BLUR EFFECT TO BACKGROUND IMAGE */
  .v-image__image {
    filter: brightness(90%) blur(2px);
  }
  </style>